angular.module('CarsSaraBo').directive('markupComponent', function () {
    return {
        restrict: 'E',
        controller: ['MarkupService', 'DateService', '$q', '$translate', 'MarkupGAConfig', 'NotificationService', 'SessionService', 'LoadingWheelService', 'ModalService', MarkupController],
        controllerAs: 'ctrl',
        templateUrl: 'templates/markup/markup.component.html',
        scope: {} // isolated scope
    };
});

function MarkupController(markupService, dateService, $q, $translate, markupGAConfig, notificationService, sessionService, loadingWheelService, modalService) {
    var vm = this;

    vm.optionLists = {'COMPANY': [], 'CAR_CATEGORY': []};
    vm.markupSearch = {
        netFilter: [{category: null, items: []}],
        dateRange: null
    };
    vm.tableTree = [];
    vm.isPrevisualized = false;
    vm.markup = {percentage: null};
    vm.markups = {};
    vm.hasSearch = false;
    vm.isEditable = sessionService.loggedUserAllowed("PERM_MARKUP_CREATE");

    function initialize() {
        getViewData();
    }

    var gaMarkup = markupGAConfig.markupGa();

    function getViewData() {
        $q.all([markupService.getCompanyMarkup(null, null), markupService.getCategoryMarkup(null, null), markupService.fetchCategories()])
            .then(function (response) {
                vm.optionLists['COMPANY'] = response[0].data;
                vm.optionLists['CAR_CATEGORY'] = {codes: response[1].data, 'pt': [], 'es': [], 'en': []};
                vm.filterCategories = response[2].data;
            });
    }

    vm.getFilterCategories = function (selected) {
        var copyList = angular.copy(vm.filterCategories);
        var copyFilter = vm.markupSearch.netFilter;
        return _.filter(copyList, function (category) {
            return !_.some(copyFilter, function (filter) {
                return (filter.category === category) && (selected != category);
            })
        });
    }

    /***********   Start search   ***********/
    vm.previsualizeIt = function () {
        vm.errorField = [];
        if (isValidPrevisualized() && vm.markupPrevisualizedForm.$valid) {
            gaMarkup.send("Previsualizar", vm.markup.percentage)
            vm.isPrevisualized = true;
        } else {
            handleDefaultErrors(vm.markupPrevisualizedForm);
        }
    }

    vm.selectCriteriaCategory = function (filter) {
        filter.items = [];
        gaMarkup.send("Seleccionar_criterio_busqueda", filter.category);
    }

    function isValidMarkup(toValidate) {
        var percentagePattern = /^[0-9]{1,2}([,.][0-9]{1,2})?$/;
        return percentagePattern.test(toValidate);
    }

    function isValidPrevisualized() {
        var isValid = true;
        var isInvalidPercentage = !isValidMarkup(vm.markup.percentage);
        if ((vm.markup != undefined) && isInvalidPercentage) {
            isValid = false;
            vm.errorField['markupPercentage'] = {
                invalid: true,
                message: "warning.invalidNumberFormat"
            };
        }
        return isValid;
    }

    vm.save = function () {
        var deferred = $q.defer();
        loadingWheelService.show();
        var period = {
            from: vm.searchDate.toPostFrom,
            to: vm.searchDate.toPostTo
        }
        gaMarkup.send("Guardar_todo", vm.markup.percentage);
        var percentage = parseValidAmount(vm.markup.percentage);
        markupService.save(percentage, vm.tableTree, period)
            .then(function (response) {
                vm.search(true);
                notificationService.displayToast('markup.toast.MARKUP_MODIFIED');
                deferred.resolve();
            }, function (error) {
                deferred.reject();
                console.error("Error while trying to save.", error);
            })
            .finally(function (response) {
                loadingWheelService.hide();
            });
        return deferred.promise;
    };

    function parseValidAmount(amount) {
        return parseFloat(amount.replace(",", "."));
    }

    vm.getMarkups = function (companyOid, pointOfSaleOid, category) {
        //start loader
        if (!vm.markups[category]) {
            vm.markups[category] = {};
        }
        if (!vm.markups[category][pointOfSaleOid]) {
            loadingWheelService.show();
            var period = {
                from: vm.searchDate.toPostFrom,
                to: vm.searchDate.toPostTo
            }
            // get markup
            // vm.markups[category][posId] = markupService.fetchMarkupsByPosAndCategory();
            markupService.getMarkups(companyOid, pointOfSaleOid, category, period).success(function (response) {
                vm.markups[category][pointOfSaleOid] = response;
                loadingWheelService.hide();
            });
        }
    }

    vm.posPanelInteraction = function (posCollapsed, posName, category, company) {
        gaMarkup.send(posCollapsed ? "Colapsar_sucursal" : "Expandir_sucursal", posName, category, company);
    }

    vm.categoryPanelInteraction = function (categoryCollapsed, category, company) {
        gaMarkup.send(categoryCollapsed ? "Colapsar_categoria" : "Expandir_categoria", category, company);
    }

    vm.cancel = function () {
        modalService.show("CANCEL_ALERT_TITLE", "CANCEL_MARKUP_DESCRIPTION", function () {
            vm.isPrevisualized = false;
            gaMarkup.send("Cancelar")
        });
    };

    vm.search = function (avoidNotify) {
        var deferred = $q.defer();
        loadingWheelService.show();
        vm.hasSearch = false;
        vm.markup = {percentage: null}
        vm.isPrevisualized = false;
        vm.tableTree = [];
        vm.markups = {};
        vm.errorField = [];
        if (isValidForm() && vm.markupForm.$valid) {
            vm.searchDate = {
                toPostFrom: dateService.customFormatDate(vm.markupSearch.dateRange.from, "yyyyMMdd"),
                toPostTo: dateService.customFormatDate(vm.markupSearch.dateRange.to, "yyyyMMdd"),
                from: dateService.customFormatDate(vm.markupSearch.dateRange.from, "dd/MM/yyyy"),
                to: dateService.customFormatDate(vm.markupSearch.dateRange.to, "dd/MM/yyyy")
            }

            var dimensions = getSelectedDimensions();
            if (!avoidNotify) {
                gaMarkup.send("Buscar", dimensionsAsString(dimensions));
            }
            //hago la llamada al servicio que me retorna el esqueleto de la tabla
            markupService.fetchTableMetadata(dimensions).then(function (metadata) {
                vm.hasSearch = true;
                vm.tableTree = angular.copy(metadata.data);
                deferred.resolve();
            }).finally(function (response) {
                loadingWheelService.hide();
            });

        } else {
            loadingWheelService.hide();
            handleDefaultErrors(vm.markupForm);
            deferred.reject();
        }

        return deferred.promise;
    };

    function dimensionsAsString(dimensions) {
        var company = !dimensions.companies ? "" : "Company:" + _.reduce(dimensions.companies.items, function (memo, company) {
                return (!memo) ? company.name : (memo + ", " + company.name);
            }, "");
        var categories = !dimensions.carCategories ? "" : "Category:" + _.reduce(dimensions.carCategories.items, function (memo, category) {
                return (!memo) ? category.name : (memo + ", " + category.name);
            }, "");
        return ((!company ? categories : company + "; " + categories) + "; " + ("Periodo:" + vm.searchDate.from + "-" + vm.searchDate.to));
    }

    function getSelectedDimensions() {
        var dimensions = {
            companies: _.find(vm.markupSearch.netFilter, {category: 'COMPANY'}),
            carCategories: _.find(vm.markupSearch.netFilter, {category: 'CAR_CATEGORY'})
        };
        return dimensions;
    }

    function handleDefaultErrors(form) {
        for (i in form.$error.required) {
            vm.errorField[form.$error.required[i].$name] = {
                // class: "-invalid",
                invalid: true,
                message: "common.form.validation.UNCOMPLETE_REQUIRED_FIELD"
            };
        }
    }

    function isValidForm() {
        var isValid = true;
        if (vm.markupSearch.dateRange) {
            var period = vm.markupSearch.dateRange;
            if (!dateService.isValidFromDate(period)) {
                isValid = false;
                vm.errorField['markupDateRange-from'] = {
                    // class: "-invalid",
                    invalid: true,
                    message: "common.INPUT_INVALID_DATE"
                };
            }
            if (!dateService.isValidToDate(period)) {
                isValid = false;
                vm.errorField['markupDateRange-to'] = {
                    // class: "-invalid",
                    invalid: true,
                    message: "common.INPUT_INVALID_DATE"
                };
            }
        }

        var filters = vm.markupSearch;
        _.each(filters.netFilter, function (filter) {
            if (filter.category && (!filter.items || !(filter.items.length > 0))) {
                vm.errorField['autocomplete-input-' + filter.category] = {
                    invalid: true,
                    message: "common.form.validation.UNCOMPLETE_REQUIRED_FIELD"
                };
                isValid = false;
            }
        })
        return isValid;
    }

    /***********   End search   ***********/

    /***********   Start Filter component   ***********/
    vm.addFilter = function () {
        gaMarkup.send("Agregar_criterio_busqueda")
        vm.markupSearch.netFilter.push({category: null, items: []})
    }

    vm.deleteCategory = function (filter) {
        gaMarkup.send("Criterio_borrar", filter.category);
        var index = _.indexOf(vm.markupSearch.netFilter, filter);
        vm.markupSearch.netFilter.splice(index, 1);
    }

    vm.deleteSelectedItems = function (filter) {
        gaMarkup.send("Criterio_eliminar_todos", filter.category);
        filter.items = [];
    }

    vm.addAllItems = function (filter) {
        gaMarkup.send("Criterio_seleccionar_todos", filter.category);
        filter.items = [];
        var list = vm.getList(filter.category);
        _.each(list, function (elem) {
            filter.items.push(elem);
        })
    }

    vm.getList = function (category) {
        if (!category) {
            return [];
        }
        if (category === 'CAR_CATEGORY') {
            var lang = $translate.use();
            if (!vm.optionLists[category][lang] || vm.optionLists[category][lang].length == 0) {
                _.each(vm.optionLists['CAR_CATEGORY'].codes, function (item) {
                    vm.optionLists['CAR_CATEGORY'][lang].push({
                        code: item,
                        name: $translate.instant('cars.category.' + item)
                    });
                })
            }
            return vm.optionLists[category][lang];
        }
        return vm.optionLists[category];
    }

    vm.refreshOptions = function (input, category) {
        if (!category) {
            return;
        }
        var filters = vm.markupSearch.netFilter;
        var index = _.findIndex(filters, function (filter) {
            return filter.category === category
        });
        getListByCategory(category, filters, input);
    };

    function getListByCategory(category, filters, nameLike) {
        categoryOptionsResolver.get(category, nameLike, filters)
    }

    function categoryOptionsResolver() {
        var mapInfo = {
            "COMPANY": function (nameLike, filter) {
                markupService.getCompanyMarkup(nameLike, filter).then(function (response) {
                    vm.optionLists['COMPANY'] = response.data
                });
            },
            "CAR_CATEGORY": function (nameLike, filter) {
                markupService.getCategoryMarkup(nameLike, filter).then(function (response) {
                    vm.optionLists['CAR_CATEGORY'] = response.data
                });
            }
        }
        return {
            get: function (category, param1, param2) {
                mapInfo[category].call(mapInfo, param1, param2);
            }
        }
    }

    var categoryOptionsResolver = categoryOptionsResolver();


    vm.getNoCarCategory = function (categoriesWithCars) {
        var categories = _.find(vm.markupSearch.netFilter, {category: 'CAR_CATEGORY'});
        var items = [];
        if (!!categories) {
            items = categories.items;
        }
        return (categoriesWithCars.length === items.length) ? [] : getUncontainedItems(items, categoriesWithCars);
    }

    function getUncontainedItems(listA, listB) {
        return _.filter(listA, function (item) {
            return !_.includes(listB, item.code);
        })
    }

    vm.getDay = function (date) {
        var momentDate = moment(date)._d;
        return $translate.instant('common.week.short.' +
                (momentDate).getDay()) + " " + date.substr(date.length - 2) + ", " +
            $translate.instant('common.month.short.' + ((momentDate).getMonth() + 1));
    }

    vm.notifyGA = function (eventName, param1, param2) {
        gaMarkup.send(eventName, param1, param2);
    }
    /***********   End Filter component   ***********/

    initialize();
}



//////////////////
// WEBPACK FOOTER
// ./public/app/markup/markup.component.js
// module id = 889
// module chunks = 3